import { mapState } from 'pinia'
import { useTrackStore } from '@/stores/track'

export default {
    computed: {
        ...mapState(useTrackStore, { trackResponseTokens: 'responseTokens' }),
    },
    methods: {
        responseToken(response) {
            let responseTokens = this.trackResponseTokens
            return responseTokens[response.name]
        }
    }
}
